export const wcconfig = {
  assets: {
    ajaxIndicator:
      "https://firebasestorage.googleapis.com/v0/b/abacus-online-reservation-test.appspot.com/o/Assets%2FImages%2FProgressIndicator.gif?alt=media&token=429c3675-fb7a-4faa-b5f9-c044f40187f4",
    abacus:
      "https://firebasestorage.googleapis.com/v0/b/abacus-online-reservation-test.appspot.com/o/Assets%2FImages%2Fapp.abacus.co-logo.png?alt=media&token=61ee5f31-14cb-4c2e-9f76-7aa7c674fc17"
  }
};
